<template>
  <div class="weiboGroup">
    <div
      class="item"
      v-for="(item, index) in groupData"
      :key="index"
      @click="navigateToWeibo($event, item.weiboUrl)"
    >
      <img
        :src="
          require('../../assets/images/weibo/wbicon-' + item.imgUrl + '.jpg')
        "
        alt=""
      />
      <a href="#" class="text">{{ item.text }}天气</a>
    </div>
  </div>
</template>

<script>
export default {
  created () {
    this.baseApi = process.env.VUE_APP_BASE_API
  },
  data () {
    return {
      groupData: [{
        text: '广州',
        imgUrl: 'guangzhou',
        weiboUrl: 'http://weibo.com/u/2294193132'
      }, {
        text: '白云',
        imgUrl: 'baiyun',
        weiboUrl: 'http://weibo.com/byweather'
      }, {
        text: '花都',
        imgUrl: 'huadu',
        weiboUrl: 'http://weibo.com/hdqx12121'
      }, {
        text: '番禺',
        imgUrl: 'panyu',
        weiboUrl: 'http://weibo.com/u/2311093730'
      }, {
        text: '南沙',
        imgUrl: 'nansha',
        weiboUrl: 'http://weibo.com/u/1351653603'
      }, {
        text: '黄埔',
        imgUrl: 'huangpu',
        weiboUrl: 'http://weibo.com/lgqx'
      }, {
        text: '从化',
        imgUrl: 'conghua',
        weiboUrl: 'http://weibo.com/conghuatianqi'
      }, {
        text: '增城',
        imgUrl: 'zengcheng',
        weiboUrl: 'http://weibo.com/zcweather'
      }],

      // 接口url
      baseApi: ''
    }
  },
  methods: {
    // 跳转到微博
    navigateToWeibo ($event, weiboUrl) {
      window.open(weiboUrl)
    }
  }
}
</script>

<style lang="less" scoped>
.weiboGroup {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  .item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 69px;
    margin: 10px;
    border: 1px solid #e4e2df;
    font-size: 14px;
    cursor: pointer;
    img {
      width: 50px;
      height: 50px;
    }
    .text {
      margin-top: 5px;
    }
  }
}
</style>
